import { Nav } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { Link, Outlet, useLocation } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import { useEffect, useState } from 'react';

const Patient = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname.endsWith(path);
  const [clinic, setClinic] = useState<any>(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    getClinic();
  }, []);

  const getClinic = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/clinic/get`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data.status === false) return;

      setClinic(response.data.data.clinic);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card className="col-12">
      <Card.Header>
        <div className="d-sm-flex justify-content-between">
          <h2>Edit Patient</h2>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="mb-3">
          <Nav variant="underline">
            <Nav.Item>
              <Link
                to="profile"
                className={`nav-link ${isActive('profile') ? 'active' : ''}`}
              >
                Profile
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link
                to="reports"
                className={`nav-link ${isActive('reports') ? 'active' : ''}`}
              >
                Reports
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link
                to="food-data"
                className={`nav-link ${isActive('food-data') ? 'active' : ''}`}
              >
                Food Data
              </Link>
            </Nav.Item>
            <Nav.Item>
              <Link
                to="meal-plan"
                className={`nav-link ${isActive('meal-plan') ? 'active' : ''}`}
              >
                Meal Plan
              </Link>
            </Nav.Item>
            <NavDropdown
              title="Goals"
              id="goals-dropdown"
              style={{ padding: '0px' }}
              className={`nav-link ${
                location.pathname.includes('goals') ? 'active' : ''
              }`}
            >
              <NavDropdown.Item
                as={Link}
                to="goals/weight"
                className={isActive('goals/weight') ? 'active' : ''}
              >
                Weight
              </NavDropdown.Item>
              <NavDropdown.Item
                as={Link}
                to="goals/hba1c"
                className={isActive('goals/hba1c') ? 'active' : ''}
              >
                HbA1C
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </div>
        <Outlet context={{ clinic }} />
      </Card.Body>
    </Card>
  );
};

export default Patient;
